
import { ErrorHandler, Injectable } from '@angular/core';
@Injectable()
export class ElekErrorHandler  extends ErrorHandler 
{
    constructor() 
    {
        super();
    }
    

    handleError(error: any): void
    {
       
        super.handleError(error);
               
    }
}

